import { Navigate, Route, Routes } from 'react-router';
import { Toaster } from 'sonner';
import LoginPage from './routes/LoginPage';
import DashboardPage from './routes/DashboardPage';
import SocialOverviewPage from './routes/SocialOverviewPage';
import FacebookPage from './routes/FacebookPage';
import InstagramPage from './routes/InstagramPage';
import IGStoriesPage from './routes/IGStoriesPage';
import Ga4Page from './routes/Ga4Page';
import Ga4TrafficPage from './routes/Ga4TrafficPage';
import SettingsUsersPage from './routes/SettingsUsersPage';
import SettingsRestaurantsPage from './routes/SettingsRestaurantsPage';
import SettingsPreferencesPage from './routes/SettingsPreferencesPage';
import DashboardLayout from './components/layout/DashboardLayout';
import { RedirectIfLoggedIn, RequireAdmin, RequireAuth } from './components/auth/Guards';

export default function App() {
  return (
    <>
    <Toaster position="bottom-right" richColors closeButton />
    <Routes>
      <Route element={<RedirectIfLoggedIn />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/social" element={<SocialOverviewPage />} />
          <Route path="/dashboard/social/facebook" element={<FacebookPage />} />
          <Route path="/dashboard/social/instagram" element={<InstagramPage />} />
          <Route path="/dashboard/social/instagram/stories" element={<IGStoriesPage />} />
          <Route path="/dashboard/ga4" element={<Ga4Page />} />
          <Route path="/dashboard/ga4/traffic" element={<Ga4TrafficPage />} />

          <Route element={<RequireAdmin />}>
            <Route path="/dashboard/settings" element={<Navigate to="/dashboard/settings/restaurants" replace />} />
            <Route path="/dashboard/settings/restaurants" element={<SettingsRestaurantsPage />} />
            <Route path="/dashboard/settings/users" element={<SettingsUsersPage />} />
            <Route path="/dashboard/settings/preferences" element={<SettingsPreferencesPage />} />

            {/* legacy redirects */}
            <Route path="/dashboard/admin" element={<Navigate to="/dashboard/settings/users" replace />} />
            <Route path="/dashboard/admin/users" element={<Navigate to="/dashboard/settings/users" replace />} />
            <Route path="/dashboard/admin/groups" element={<Navigate to="/dashboard/settings/restaurants" replace />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
    </>
  );
}
